import { safeStringify, shortUID } from "@pufflig/prompt-tools";
import { HostAPI } from "@pufflig/promptbook-code-sandbox";
import { SQLDatabase } from "@pufflig/promptbook-db";
import { createThread } from "../connection/threads/threads";

interface CreateHostAPIParams {
  db: SQLDatabase;
  connection: WebSocket;
}

export const createHostAPI = (params: CreateHostAPIParams): HostAPI => {
  const { db, connection } = params;
  return {
    connection: {
      /**
       * Send a message to the websocket connection and track the completion.
       *
       * @param payload
       * @returns
       */
      send: async (payload) => {
        const threadId = shortUID("thd");
        const promise = createThread(threadId, payload);
        connection.send(safeStringify({ ...payload, threadId }));
        return promise;
      },
    },
    db: {
      createTableFromResult: async (result) => {
        return db.createTableFromResult(result);
      },
      describeTable: async (tableName) => {
        return db.describeTable(tableName);
      },
    },
  };
};
